<template>
  <div style="margin-right: 1em;">
    <div class="form-row">
      <div class="form-group col-6">
        <label 
          class="required"
          style="margin-top: 1em;"
        >
          {{ $t('resource.format.label') }}
        </label>
        <p class="label-help">
          {{ $t('resource.format.help') }}
        </p>
        <ValidatedFileFormatSelector
          :required="isRequired"
          validation-name="Format FileDownload"
          @select="$event => form.format = $event"
        />
        <p style="margin-top: 0.5em; font-size: 0.85em; white-space: wrap;">
          {{ $t('resource.fileUpload.formatHelp') }}
        </p>
      </div>
      <!-- <div
        v-if="isMain"
        class="form-group col-6"
      >
        <label style="margin-top: 1em;">
          {{ $t('resource.scheduler.label') }}
        </label>
        <p>
          {{ $t('resource.scheduler.help') }}
        </p>
        <ValidationProvider
          v-slot="{ classes, errors }"
          name="Frequence FTP"
        >
          <div
            class="control"
          >
            <Multiselect
              v-model="form.scheduler"
              :options="schedulers"
              track-by="id"
              label="label"
              select-label=""
              selected-label=""
              deselect-label=""
              :searchable="false"
              :placeholder="$t('resource.scheduler.placeholder')"
            />
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div> -->
    </div>
    <div class="form-row">
      <div class="form-group col">
        <label 
          class="required"
          style="margin-top: 1em;"
        >
          URL
        </label>
        <p>{{ $t('resource.fileDownload.help') }}</p>
        <ValidationProvider
          v-slot="{ classes, errors }"
          name="URL"
          :rules="`${isRequired ? 'required' : ''}`"
        >
          <div
            class="control"
            :class="isRequired ? classes : ''"
          >
            <input
              v-model="form.href"
              v-sanitize
              class="form-control"
              type="text"
              placeholder="https://"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import ValidatedFileFormatSelector from '@/common/components/ValidatedFileFormatSelector.vue';

import { mapState, mapActions } from 'vuex';

import { ValidationProvider, extend, configure } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Ce champ est requis'
});
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});

export default {
  name: 'FileDownloadCreator',

  components: {
    ValidatedFileFormatSelector,
    ValidationProvider
  },

  props: {
    required: {
      type: Boolean,
      default: true
    },
    isMain: {
      type: Boolean,
      default: true
    },
  },

  data() {
    return {
      isRequired: true,
      form: {
        type: 'file-download',
        format: null,
        // scheduler: null,
        href: null
      }
    };
  },

  computed: {
    ...mapState('resources', [
      'schedulers'
    ]),

    isGeospatial() {
      return this.form.format && this.form.format.type.value === 'geospatial';
    },
    isXY() {
      return this.form.format && this.form.format.type.value === 'tabular-xy';
    }
  },

  watch: {
    required(newValue) {
      this.isRequired = newValue;
    },
    form: {
      deep: true,
      handler(newValue) {
        if (newValue.format || newValue.href) {
          this.setRequired(true);
        } else {
          this.setRequired(false);
        }
      }
    },
    'form.href': function() {
      this.setResourceURL();
    },
    'form.format': function() {
      this.setResourceURL();
    },
    isGeospatial(newValue) {
      this.$emit('geo', newValue);
      this.$emit('xy', this.form.format && this.form.format.type.value === 'tabular-xy');
    },
    isXY(newValue) {
      this.$emit('xy', newValue);
    }
  },

  created() {
    this.isRequired = this.required;
    this.$emit('geo', this.isGeospatial);
    this.$emit('xy', this.isXY);
    // if (this.GET_SCHEDULERS.length === 0) {
    //   this.GET_SCHEDULERS();
    // }
  },

  methods: {
    ...mapActions('resources', [
      'GET_SCHEDULERS'
    ]),

    setRequired(e) {
      this.isRequired = e;
      this.$emit('set', {
        required: this.isRequired
      });
    },

    setResourceURL() {
      this.$emit('set', {
        form: this.form,
        required: this.isRequired
      });
    }
  }  
};
</script>
